import { useFirebaseAuth } from '@/services';

const signIn = async (data: { code: string }) => {
  const { auth, providers } = useFirebaseAuth();

  const headersList = {
    Accept: '*/*'
  };

  const params = new URLSearchParams({
    client_id: process.env.VUE_APP_GAPI_CLIENT_ID ?? '',
    client_secret: process.env.VUE_APP_GAPI_CLIENT_SECRET ?? '',
    code: data.code,
    grant_type: 'authorization_code',
    redirect_uri: 'postmessage'
  });

  const response = await fetch(`https://oauth2.googleapis.com/token?${params.toString()}`, {
    method: 'POST',
    headers: headersList
  });

  const dataResponse = await response.text();
  const { access_token: accessToken, id_token: idToken, refresh_token: refreshToken } = JSON.parse(dataResponse);

  const credential = providers.GoogleAuthProvider.credential(idToken, accessToken);
  const authInfo = await auth.signInWithCredential(credential);

  return { authInfo, refreshToken };
};

const signOut = async () => {
  const { auth } = useFirebaseAuth();

  auth.signOut();
};

const ensureAuth = (onEmptyAuthState: () => void): boolean => {
  const { ensureFirestoreAuth } = useFirebaseAuth();

  return ensureFirestoreAuth(onEmptyAuthState);
};

export const useAuth = () => ({
  signIn,
  signOut,
  ensureAuth
});
